import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";
import { useMorphemePanelsPageNavigatorOptions } from "@-/dev.improve.haniverse.lib.morpheme.page.navigator";
import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { usePathname } from "@-/com.npmjs.expo-router";
import { useCallback } from "react";

const BROWSE_MORPHEME_HREF =
  "/(nav)/(app)/browse/morpheme/[morpheme]" satisfies MorphemeHrefObject["href"];
const SEARCH_MORPHEME_HREF =
  "/(nav)/(app)/search/card/[morpheme]" satisfies MorphemeHrefObject["href"];

function useNavigator() {
  const getMorphemePanelsPageNavigatorOptions = useMorphemePanelsPageNavigatorOptions();
  const pathname = usePathname();
  const morphemeHref =
    pathname === "/search" || pathname.startsWith("/search/")
      ? SEARCH_MORPHEME_HREF
      : BROWSE_MORPHEME_HREF;

  return useCallback(
    ({ morpheme, params = {} }: { morpheme: string; params?: MorphemeHrefObject["params"] }) =>
      getMorphemePanelsPageNavigatorOptions({
        morpheme,
        // Browsing a character on web opens the single-scroll Reference view; native keeps the
        // Info/Mnemonics pager. The bare native route also redirects into that pager.
        prefer: "reference",
        prefix: { href: morphemeHref, params },
      }),
    [getMorphemePanelsPageNavigatorOptions, morphemeHref],
  );
}

export const useBrowseMorphemePageNavigator = createPageNavigator({
  useNavigator,
});
